import { tabelaMovimentoContabilStyles } from './TabelaMovimentoContabil.style'

export function tabelaMovimentoContabilIO() {
  return {
    styles: tabelaMovimentoContabilStyles
  }
}

export type TabelaMovimentoContabilIO = ReturnType<typeof tabelaMovimentoContabilIO>
